import { getLocalStorageItem } from "~/lib/localStorage";

export interface CampaignParams {
  utm_campaign?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_content?: string;
  utm_term?: string;
  gclid?: string;
  msclkid?: string;
}

/**
 * Synchronously retrieves stored campaign parameters from localStorage
 * @returns The stored campaign parameters object or null if none exist
 */
export const getCampaignParams = (): CampaignParams | null => {
  return getLocalStorageItem("campaignParams");
};
